import { useMemo } from 'react';
import { NavLink, Outlet, useParams } from 'react-router-dom';

import { useConfig } from '@occc/config';
import { Tab, Tabs } from '@occc/ui-design-system';
import { ProtectedRoute } from '@occc-app/App/routes/ProtectedRoute';
import { Page, useAppLayoutContextConsumer } from '@occc-app/design-system';
import { Feature } from '@occc/utils-access-control';

import { PAGE_SUBTITLE, PAGE_TITLE } from './triggered-messages-list.constants';

import { routeCreator, getListLinks } from '../triggered-messages.utils';

export const TriggeredMessagesListLayout = () => {
  useAppLayoutContextConsumer(useMemo(() => getListLinks().links, []));

  const { config } = useConfig();
  const { scope } = useParams<{ scope?: string }>();
  const scopeList = config.subBrands?.enabled ? config.subBrands.list : [];
  const canRenderTabs = scopeList.length > 1;

  return (
    <ProtectedRoute feature={Feature.TRIGGERED_MESSAGES_VIEW}>
      <Page
        browserTabTitle={PAGE_TITLE}
        pageHeaderProps={{
          title: PAGE_TITLE,
          subtitle: PAGE_SUBTITLE,
        }}
      >
        {canRenderTabs ? (
          <Tabs color='secondary' value={scope}>
            {scopeList.map((scope) => (
              <Tab
                key={scope.uuid}
                label={scope.name}
                value={scope.uuid}
                component={NavLink}
                to={routeCreator.listByScope.to(scope.uuid)}
              />
            ))}
          </Tabs>
        ) : null}
        <Outlet />
      </Page>
    </ProtectedRoute>
  );
};
